import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { isNil } from "lodash";

import { Toast } from "primereact/toast";

import { useStore } from "../../../../stores/StoreContext";
import { IToast } from "../../../../stores/ToastStore";

const CallableToastRaw: FunctionComponent = () => {
  const { t } = useTranslation();
  const toastRef = useRef<Toast>(null);
  const [toastData, setToastData] = useState<IToast>();

  const { toastStore } = useStore();

  useEffect(() => {
    const showToast = (toast: IToast) => {
      let delay = toast.delay ?? 0;

      if (toastData?.replace) {
        toastRef.current?.clear();
        delay = 1000;
      }

      setTimeout(() => {
        toastRef.current?.show({
          severity: toast.severity,
          summary: toast.summary.translationKey ? t(toast.summary.translationKey) : toast.summary.message,
          detail: toast.detail.translationKey
            ? t(toast.detail.translationKey, toast.detail.translationParams)
            : toast.detail.message,
          life: toast.life ?? 5000,
          sticky: toast.sticky,
        });
        setToastData(toast);
      }, delay);
    };

    if (toastStore.toastCount > 0) {
      const toast = toastStore.processNextToast();
      if (toast) {
        showToast(toast);
      }
    }
  }, [toastStore.toastCount]);

  return <Toast ref={toastRef} position={toastData?.position ?? "top-right"} />;
};

export const CallableToast = observer(CallableToastRaw);
